import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LocomotiveScroll from 'locomotive-scroll';

gsap.registerPlugin(ScrollTrigger);

const locoScroll = new LocomotiveScroll({
  el: document.querySelector('[data-scroll-container]'),
  smooth: true,
  // smartphone: { smooth: true },
  // tablet: { smooth: true },
  smoothMobile: true,
  smoothTablet: true,
  // reloadOnContextChange: true,
  mobile: {
    smooth: true
  },
  tablet: {
      smooth: true
  }
});

locoScroll.on('scroll', ScrollTrigger.update);

ScrollTrigger.scrollerProxy('[data-scroll-container]', {
  scrollTop(value) {
    return arguments.length ? locoScroll.scrollTo(value, 0, 0) : locoScroll.scroll.instance.scroll.y;
  }, 
  getBoundingClientRect() {
    return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
  },
  pinType: document.querySelector('[data-scroll-container]').style.transform ? "transform" : "fixed"
});

ScrollTrigger.addEventListener('refresh', () => locoScroll.update());

export default locoScroll;